import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class HttpClientWithCache extends HttpClient {
  memCache: any = {};

  /**
   * make a get request to an endpoint but store the response data in localstorage or memory
   * so that next time client can respond immediately with old data before getting the potentially updated server response
   *
   * @param url     The endpoint URL.
   * @param [options]
   * @return An `Observable` of the `HttpResponse`, with a response body in the requested type.
   */

  // FIXME: This method does not support any error handling
  getWithCache<T>(url: string, options?: any): Observable<T> {

    return new Observable(subscriber => {
      const preliminaryResult = this.memCache[url] || localStorage.getItem(url);
      if (preliminaryResult) {
        // found prelim result
        subscriber?.next(JSON.parse(preliminaryResult) as T);
      }

      (async () => {
        const res = await this.get<T>(url, options).toPromise();
        try {
          localStorage.setItem(url, JSON.stringify(res));
        } catch (e: any) {
          if (e.message.match(/exceeded the quota/)) {
            console.warn('response too large for localstorage, fallback to memory');
            this.memCache[url] = JSON.stringify(res);
          } else {
            console.warn('caching error', e);
          }
        }
        // actual result
        // @ts-ignore
        subscriber?.next(res);
        subscriber?.complete();
      })();
    });
  }

}
